// extracted by mini-css-extract-plugin
export default {"TableFiltering":"_TableFiltering--i3_kT"};